import React, { Component } from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import { LinkContainer, MenuLink, ChildLinkContainer, MenuArrow } from './NavigationItem.style'
import ArrowDown from '../Icons/ArrowDown'
import { isMobile } from '../../../utils/siteHelper'

class NavigationItem extends Component {
  state = {
    childMenuOpen: false,
  }

  openChildMenu = () => {
    const { childMenuOpen } = this.state
    this.setState({
      childMenuOpen: !childMenuOpen,
    })
  }

  render() {
    const { title, pageLink, childItems, mobileOnly, enableClick, lighttheme, sticky } = this.props
    const { childMenuOpen } = this.state

    return (
      childItems && childItems.length > 0
        ? (
          <LinkContainer
            onClick={enableClick ? this.openChildMenu : undefined}
          >
            <MenuLink
              as={isMobile() ? 'span' : ''}
              to={isMobile() ? '' : pageLink.slug}
              mobilefont={mobileOnly}
              lighttheme={lighttheme}
            >
              {title}
              <MenuArrow viewBox="0 0 21 12" expandMenu={childMenuOpen}><ArrowDown /></MenuArrow>
            </MenuLink>
            <ChildLinkContainer expandMenu={childMenuOpen} sticky={sticky}>
              {
                childItems.map(link => (
                  <LinkContainer key={link.id}>
                    <MenuLink
                      to={link.pageLink.slug}
                      lighttheme={lighttheme}
                    >
                      {link.title}
                    </MenuLink>
                  </LinkContainer>
                ))
              }
            </ChildLinkContainer>
          </LinkContainer>
        )
        : (
          <LinkContainer>
            <MenuLink
              to={pageLink.slug}
              mobilefont={mobileOnly}
              lighttheme={lighttheme}
            >
              {title}
            </MenuLink>
          </LinkContainer>
        )
    )
  }
}

NavigationItem.propTypes = {
  title: PropTypes.string.isRequired,
  pageLink: PropTypes.shape({
    slug: PropTypes.string,
  }).isRequired,
  mobileOnly: PropTypes.bool,
  enableClick: PropTypes.bool,
  lighttheme: PropTypes.bool,
  childItems: PropTypes.instanceOf(Array),
  sticky: PropTypes.bool,
}

NavigationItem.defaultProps = {
  childItems: null,
  mobileOnly: false,
  enableClick: false,
  lighttheme: false,
  sticky: false,
}

export default NavigationItem

export const NavigationItemFragment = graphql`
  fragment NavigationItemFragment on ContentfulNavigationItem {
    id
    title
    pageLink {
      slug
    }
    childItems {
      id
      title
      pageLink {
        slug
      }
    }
  }
`
